import { useAppSelector } from '~/redux/hooks'

import { selectVideoTopicColor } from '../slices/vcc-data.slice'

export default function LevelTag({ level }: { level: number | string }): React.ReactElement {
  const topicColorClasses = useAppSelector(selectVideoTopicColor)

  return (
    <div className="bg-white w-12 h-12 rounded-full mx-auto flex justify-center items-center mt-4">
      <label className={`text-lg font-semibold ${topicColorClasses.textClass}`}>{level}</label>
    </div>
  )
}
